export const DEFAULT_CONTENT_URL = 'https://pmd.cdn.turner.com/xslo/cvp/assets/video/blank.mp4';
export const DEFAULT_MIME_TYPE = 'video/mp4';
export const DEFAULT_POSTER = 'http://i.cdn.turner.com/adultswim/big/video/mainstream/liveStream.jpg';
export const DEFAULT_VIDEO_ID = '666';
export const EMBED_CODE_L = '<iframe width=\'560\' height=\'315\' src=\'';
export const EMBED_CODE_R = '\' frameborder=\'0\' allowfullscreen></iframe>';
export const EMBED_URL = '//www.adultswim.com/player/embed/';
export const ERROR_FETCHING_SOURCE_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2018/08/03/ERROR_FETCHING_SOURCE.png';
export const FACEBOOK_SHARE_URL = 'https://facebook.com/sharer.php?u=';
export const FORBIDDEN_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2017/07/27/geoBlock2.jpg';
export const HLS_MIME_TYPE = 'application/x-mpegURL';
export const LOCALSTORAGE_MUTED = 'as-player:muted';
export const NOT_FOUND_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2017/07/27/404-compressor.jpg';
export const PROBLEM_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2016/09/26/problem-1.jpg';
export const RECONNECTING_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2016/09/26/reconnecting.jpg';
export const TUMBLR_SHARE_URL = 'https://www.tumblr.com/share/link?url=';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?url=';
export const UNSUPPORTED_CSS_CLASS = 'your-browser-sux';
export const VIDEO_SOURCE_QUERY_PARAMS = { 'fields': 'title,type,duration,collection_title,poster,stream,segments,title_id' };
export const VIDEO_SOURCE_URL = (window.location.hostname.includes('adultswim.com')) ? '/api/shows/v1/videos/' : '//www.adultswim.com/api/shows/v1/videos/';
export const VIDEOS_SITE_URL = 'http://www.adultswim.com/videos/';
export const VTT_MIME_TYPE = 'text/vtt';



// WEBPACK FOOTER //
// ./src/constants.js